import styled from 'styled-components';

export const StyledGuardianSelect = styled.div`
   display: flex;
   gap: 15px;
`;
StyledGuardianSelect.displayName = 'StyledGuardianSelect';
